import { Button } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { useModalPageContent } from '../../hooks/useTermPageContent';
import { TermModalBody } from '../TermModalBody';
import { StyledLinkAccordionBody } from './LinkAccordionBody.styles';

export function LinkAccordionBody({
  href,
  handleClose,
  closeAccordionBtnLabel,
}: {
  href: string;
  closeAccordionBtnLabel: string | null;
  handleClose: () => void;
}) {
  const state = useModalPageContent(href);

  return (
    <StyledLinkAccordionBody className="">
      <TermModalBody {...state} />
      <Button className={clsx('t-font-s t-display-1 term-link-accordion-button')} callback={handleClose}>
        {closeAccordionBtnLabel}
      </Button>
    </StyledLinkAccordionBody>
  );
}
